import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { arutyps,citiescodes,arrcomptype,arradvtype,cityidfromcod } from './userdefaultdata';
import { reducearray,cnvrtdropdown } from './Defaulddbdata';
import Viewcompanies from './Viewcompanies';
import { imgb64,chekf,dfltpic } from './utility';


import { getmessage } from './Dynamictable';
export default class Advartise extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "siikaa";
	
  	}
	
    state = {

	
	cmptyeopt:"0",
        cityidopt:"0",
	citycode:'',

        name: "World",
        adtype: "0",
        Phone: null,
        msg: "",
        advtitle:"",
        typeoption: null,
        respdata: null,
	advcode: '',
        isVisible: true,
        resm: null,
        url: "",
        btndsable:false,
	imgprofilestr:"NA",
        cities:[{ value: 'DEL', label: 'Delhi' }],
	cpmtp: [{ value: 1, label: 'Individual' }],
	advtp: [{ value: 9, label: 'Other' }],
	tblfiterdata: [{pid:'', pctypeid:'', pruid:'', pcname:'', pccode:'', pcemail:'', pccontactno:'', pidproovtype:'', pidproov:'', pcreatetime:''}]
       	
       
    };

    
    utypeChangecomp(event: any) {

        const typevalue = event.value;
       
        this.setState({ cmptyeopt: typevalue });
	
       	
    }
     utypeChangecity(event: any) {

        const typevalue = event.value;
       
        this.setState({ citycode: typevalue });
        const cid = cityidfromcod(typevalue);
	 this.setState({ cityidopt: cid });

       
    }
    utypeChange(event: any) {

        const typevalue = event.value;
       
        this.setState({ adtype: typevalue });
	
    }
     titleChange(event: any) {

        const titlevalue = event.target.value;
       
        this.setState({ advtitle: titlevalue });
	event.preventDefault()
    }
	
 	
    Homehitcount() {
              
        try {
          
            //const promiseAwait = fetch(Configdata.srvurl + '/Hitcountinput');
          }
        catch (e) {
            debugger;


        }
    }
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
 getcompdata(pd: any){
	 try {
          	
	axios.get(Configdata.srvurl + '/getallcompanies')
            .then((response: any) => {
               
		const tdata = reducearray(response.data);
		 this.setState({ tblfiterdata: tdata });
                 this.setcmpdropdown(tdata);
             	
            })
            .catch((err: any) => {
                
                getmessage('Something went wrong','');
            });

                
          }
        catch (e) {
            debugger;

        }

     }	
    
    componentDidMount() {
        debugger;
        const pid = localStorage.getItem("id");
	this.getcompdata(pid);
        
        this.setserverurl();
	
	this.setState({ advtp: arradvtype });
	this.setState({ cities: citiescodes });


	

    }
    setcmpdropdown(cdata: any){
      const dpdata = cnvrtdropdown(cdata,'pid','pcname');
      this.setState({ cpmtp: dpdata });		
		
      //alert(dpdata)
     }
    typeselect(e: any){
		
		
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';
		
		e.preventDefault()

     };
    
     viewadvs(e: any){
		
		 try {
		
		const viewcompny = <Viewcompanies />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(viewcompny,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
	   	}
	    	catch(e){
		
	        }	
	
	   	e.preventDefault()	
		
	};
     insertadv(e: any){
	 try {
          	const ctcod = this.state.citycode;
                //var txtitle = document.getElementById('txttitle') as HTMLInputElement;
		//var txtphn = document.getElementById('txtphno') as HTMLInputElement;
		const title = this.state.advtitle;
		const uphn = 'NA';
            	alert(this.state.imgprofilestr);	
		const uid = localStorage.getItem("id");
                const response = axios.post(Configdata.srvurl + '/insertadv', {
    		userid: uid,
    		type_id: this.state.adtype,
    		acompanyid: this.state.cmptyeopt,
                acontryid: 1,
		acityid: this.state.cityidopt,
		atitle: title,
		photo: this.state.imgprofilestr,
		citcod: ctcod
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const adcode = result.data;
		 this.setState({ advcode: adcode });
                 const msgdata  = 'Saved successfully ' ;
		const cd =  'Code : ' + adcode;
		getmessage(msgdata,cd);
	        });		
              }
		

          }
        catch (e) {
            debugger;

        }

	
      	e.preventDefault()


     }	

    advphotoupload(e: any){
               const selectedFile = e.target.files[0];
               const ftpe = chekf(selectedFile);
               
               if(ftpe == 'png' || ftpe == 'jpeg'){
	       var base64String ="";
               imgb64(selectedFile).then((result:any) => {
	        base64String = result;
		 
                this.setState({ imgprofilestr: base64String });
		this.btnsmtenabledisable('');
    		}).catch(err => {
        	  
    		});
	       }
	       else{
 		getmessage('Please upload png or jpg file','');
	        }
	       			
          
	} 
        btnsmtenabledisable(chs: any){
		const btnsmt = document.getElementById("advbtncompsubmit");
		if(btnsmt){
			if(chs == 'disable'){
			  btnsmt.style.backgroundColor = 'red';
			  this.setState({btndsable: true});
			}
			else{
			  btnsmt.style.backgroundColor = 'green';
			 this.setState({btndsable: false});

			} 
		}
	}
	getpfpphoto(e: any){
		
		
		const el = document.getElementById("advphoto");
                this.btnsmtenabledisable('disable');
		if(el)
        	el.click();
		
                e.preventDefault()

	}

 render() {

   
     return (

         <form>
	<div className="per100" id="postmain">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		

		<tr>
		<td>
			<div className="postingrowdiv">
		<input type="text" onChange={e => this.titleChange(e) } placeholder="Enter Adv title" id="txttitle" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdropdown">
    <Select placeholder="Select Company"  onChange={e => this.utypeChangecomp(e) } id="advcomp" options={this.state.cpmtp} className="postingtxtbox" />

			</div>
		</td>
		</tr>
		
		<tr>
		<td>
			<div className="postingrowdropdown">
		<Select placeholder="Select Type"  onChange={e => this.utypeChange(e) } id="advtype" options={this.state.advtp} className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdropdown">
	<Select placeholder="Select City"  onChange={e => this.utypeChangecity(e) } id="advcity" options={this.state.cities} className="postingtxtbox" />
			</div>
		</td>
		</tr>

		<tr>
		<td>
		<div className="postingrowdropdown">
		<a href="#" onClick={e => this.getpfpphoto(e)} >
		 <div  style={{textAlign:'center'}}  id="advimage" className="postingtxtbox">Upload Adv Image</div>
		</a>
		</div>
		</td>
		</tr>

	
		<tr>
		<td>
			<div className="postingrowdiv">
				

			<button onClick={e => this.insertadv(e)} className="searchtype" id="advbtncompsubmit" style={{backgroundColor:'gray',marginLeft:'0px',float:'right',height:'35px'}} disabled={this.state.btndsable}>
			  			Submit	
			</button>
				   
				  <a href="#" onClick={e => this.viewadvs(e)} title="Partner">

					<div className="searchtype" id="btncompview" style={{backgroundColor:'gray',marginLeft:'0px',float:'right'}}>
			  			View	
					</div>
				    </a>

				   
		     		

			</div>
			
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
				
					  
			</div>
			
		</td>
		</tr>

	   </table>
	 </div>		
	</div>
	
		     <div style={{display:'none'}}>
			 <input type="file" id="advphoto" onChange={e => this.advphotoupload(e)} />
		     </div>
	
	</div>
   	</form>
    
   
      );
}
}

